/*
 * Size dots on a product card: hovering or clicking one previews that size on
 * the card image and points the card links at the variant. Mirrors the
 * behaviour of CardProductSwatch in theme.js, which does the same for colours.
 */
if (!customElements.get('card-product-size-dots')) {
  class CardProductSizeDots extends HTMLElement {
    connectedCallback() {
      const card = this.closest('.card-product');
      if (!card) return;

      this.image = card.querySelector('.product-first-image img');
      this.links = card.querySelectorAll('.product-link');
      this.dots = this.querySelectorAll('.size-dot');

      if (this.image) {
        this.defaultSrc = this.image.getAttribute('src');
        this.defaultSrcset = this.image.getAttribute('srcset');
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.setActiveDot(dot);
          this.showSize(dot);
        });

        dot.addEventListener('mouseenter', () => this.showSize(dot));

        dot.addEventListener('mouseleave', () => {
          const active = this.querySelector('.size-dot.active');
          if (active) this.showSize(active);
        });
      });
    }

    setActiveDot(dot) {
      this.dots.forEach((other) => {
        const isActive = other === dot;
        other.classList.toggle('active', isActive);
        other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    showSize(dot) {
      this.updateProductImage(dot);
      this.updateProductLink(dot);
    }

    updateProductImage(dot) {
      if (!this.image) return;

      // The image-fade-in animation fills forwards and ends on
      // scale(var(--display-scale)), so the animated value outranks any inline
      // transform: the custom property has to move with it or nothing changes.
      // --display-scale is also what the mobile breakpoint's own scale reads.
      const scale = dot.dataset.scale || '1';
      this.image.style.setProperty('--display-scale', scale);
      this.image.style.transform = `scale(${scale})`;

      // A dot only carries an image when its variant's differs from the card's.
      const srcset = dot.dataset.srcset || this.defaultSrcset;
      const src = dot.dataset.src || this.defaultSrc;
      if (srcset && this.image.getAttribute('srcset') !== srcset) {
        this.image.srcset = srcset;
      }
      if (src && this.image.getAttribute('src') !== src) {
        this.image.src = src;
      }
    }

    updateProductLink(dot) {
      if (!this.links || this.links.length === 0) return;

      const newLink = dot.dataset.link;
      if (!newLink) return;
      this.links.forEach((link) => {
        link.href = newLink;
      });
    }
  }

  customElements.define('card-product-size-dots', CardProductSizeDots);
}
